import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import { createEpicMiddleware } from 'redux-observable';
import { ThemeProvider } from 'styled-components';
import * as Sentry from '@sentry/browser';
import reduxCatch from 'redux-catch';

import { rootReducer, rootEpic } from './reducers';
import WebChat from './components/WebChat';
import ConfigContext from './context/ConfigContext';
import Launcher from './components/Launcher';

const config = window.webChatConfig;

// Sentry
if (config.enableSentry) {
  Sentry.init({ dsn: 'https://15c5862f6b334be5b4bf48c5caff5e6a@sentry.io/1485362' });
}

// eslint-disable-next-line no-unused-vars
const catchMiddlewareHandler = (error, getState, lastAction, dispatch) => {
  if (config.enableSentry) {
    Sentry.captureException(error);
  }
  console.error('Error dispatching action: ', lastAction);
};

const catchMiddleware = reduxCatch(catchMiddlewareHandler);

const makeEpicsWithDependencies = () => (action$, store) => {
  const epicDependencies = {
    ...store,
    config
  };
  return rootEpic(action$, epicDependencies);
};

const epicMiddleware = createEpicMiddleware(makeEpicsWithDependencies());

const middleware = applyMiddleware(epicMiddleware, catchMiddleware);

const store = createStore(rootReducer, middleware);

ReactDOM.render(
  <Provider store={store}>
    <ConfigContext.Provider value={config}>
      <ThemeProvider theme={config.theme}>
        {window.initialiseComponent === 'chatPanel' ? <WebChat /> : <Launcher />}
      </ThemeProvider>
    </ConfigContext.Provider>
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js